import React from "react";
import PropTypes from "prop-types";
import { NewCircularStepper } from "@bca/ui-library";

const CircularStepper = ({ mobileStepper, activeStepIndex }) => {
  return (
    <NewCircularStepper
      colorOn="bg_white"
      style={{ height: "100%", width: "100%" }}
    >
      {mobileStepper?.map((step, index) => {
        const { label, text } = step;
        let status;

        if (index < activeStepIndex) {
          status = "completed";
        } else if (index === activeStepIndex) {
          status = "active";
        } else {
          status = "default";
        }

        return (
          <NewCircularStepper.Step
            key={label}
            status={status}
            label={label}
            text={text}
          />
        );
      })}
    </NewCircularStepper>
  );
};

CircularStepper.propTypes = {
  mobileStepper: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      text: PropTypes.string,
    })
  ).isRequired,
  activeStepIndex: PropTypes.number.isRequired,
};

export default CircularStepper;
